import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { TwoValuePieChart } from "../../Common/Charts/TwoValuePieChart";
import { number_format } from "Utils";
import _ from "i18n";
import ComponentActions from "./ComponentActions";

class ValueDeskAndPieChartComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      isPresentation,
      hasComments,
      component,
      indicatorsExplanation,
      hasExplanation,
      layoutProps: { direction, scaleComponent }
    } = this.props;

    const {
      componentId,
      labels,
      data: { accounts, data },
      config: { description, annexeAttachmentCategory }
    } = component;

    const { percentage, currentValue, diffValue, unit } = accounts[0];
    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={false}
          title={labels}
          annexeAttachmentCategory={annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isComposition={isComposition}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.SimpleValueAndTinyChartComponent,
            styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
          style={
            scaleComponent && direction !== "VERTICAL"
              ? {
                  minWidth: "50%",
                  paddingTop: 0,
                  marginLeft: -55,
                  marginTop: -20
                }
              : direction === "VERTICAL" && scaleComponent
                ? {
                    minWidth: "100%",
                    paddingTop: 0,
                    marginLeft: 0,
                    marginTop: -20
                  }
                : null
          }
        >
          {!this.props.inSlideView && (
            <ComponentActions
              removeComponent={this.props.handleRemoveComponent}
              updateComponent={this.props.handleUpdateComponent}
              componentCase={this.props.ComponentCase}
              sideBar={"MultiIndicatorComponentConfig"}
              component={"ValueDeskAndPieChartComponent.png"}
            />
          )}
          <div
            className={classnames(
              direction === "VERTICAL" ? "small-12" : "medium-8 small-8",
              styles.flex_container,
              styles.align_container
            )}
            style={direction ? { marginBottom: 25 } : null}
          >
            <span
              className={classnames("medium-12 small-12", styles.main_value)}
              style={
                scaleComponent && direction !== "VERTICAL"
                  ? { fontSize: 32, lineHeight: "60px" }
                  : null
              }
            >
              {number_format(currentValue, 2, ",", " ")} {unit}
            </span>
            <span
              className={classnames(
                "medium-12 small-12",
                styles.sub_value,
                percentage > 0 ? styles.positive_value : styles.negative_value
              )}
              style={
                scaleComponent && direction !== "VERTICAL"
                  ? { fontSize: 18 }
                  : null
              }
            >
              {percentage > 0 ? _("increaseOf") : _("decreaseOf")}{" "}
              <span className={styles.positive_value}>
                {number_format(diffValue, 2, ",", " ")}{" "}
                {unit !== "none" ? unit : ""}
              </span>
            </span>
            <span className={classnames("medium-12 small-12", styles.comment)}>
              {description}
            </span>
          </div>

          <span
            className={classnames(
              direction === "VERTICAL" ? "small-12" : "medium-4 small-4",
              styles.flex_container,
              styles.align_container
            )}
          >
            <TwoValuePieChart
              data={data}
              width={scaleComponent && direction !== "VERTICAL" ? 250 : 140}
              scaled={scaleComponent && direction !== "VERTICAL"}
            />
          </span>
        </div>
      </div>
    );
  }
}

export default ValueDeskAndPieChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/ValueDeskAndPieChartComponent.js